import React from 'react';
import { useIntl } from 'react-intl-next';
import { messages } from '../messages';
import AdvancedSearchFooter from '../../../advanced-search-footer';
import { SearchFooterWrapper, FeedbackLinkWrapper, FeedbackLink } from './styled';
export const TrelloFooter = ({
  feedbackUrl,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(SearchFooterWrapper, null, /*#__PURE__*/React.createElement(AdvancedSearchFooter, rest), /*#__PURE__*/React.createElement(FeedbackLinkWrapper, null, /*#__PURE__*/React.createElement(FeedbackLink, {
    appearance: "subtle-link",
    href: feedbackUrl,
    target: "_blank"
  }, formatMessage(messages.trello_feedback_link))));
};